export let CoverageIntegration;
(function (_CoverageIntegration) {
  let Status = /*#__PURE__*/function (Status) {
    Status["ACTIVE"] = "active";
    Status["PAUSED"] = "paused";
    Status["TRIAL"] = "trial";
    Status["DELETED"] = "deleted";
    return Status;
  }({});
  _CoverageIntegration.Status = Status;
})(CoverageIntegration || (CoverageIntegration = {}));